// this file was prevaled
// This file needs to be a JavaScript file using CommonJS to work with preval
// this file was prevaled
// we're using preval because we import tokens into Fuegokit React as a module
// Cache bust: Jul 19 2023 9:34:04 GMT-0600 (This file is cached by the system's deployment tooling, so you'll need update this timestamp to rebuild this file)
// THESE CAN BE SAFELY REMOVED, LEAVING AS A REFERENCE DURING MIGRATION - M.O., 3/13/2024
// const {default: styles} = require('../temporary/styles/dist/js')
// const {default: colors} = require('@fuegokit/tokens/dist/js/cjs/atlassian/colors')
// const {default: typography} = require('@fuegokit/tokens/dist/js/cjs/atlassian/base/typography')
// const {default: radiiValues} = require('@fuegokit/tokens/dist/js/cjs/atlassian/base/radii')
// const {default: spacing} = require('@fuegokit/tokens/dist/js/cjs/atlassian/base/size')
var themePreval = {
  "theme": {
    "fontStack": {
      "normal": "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif`",
      "mono": "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace",
      "title": "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif`",
      "sansSerif": "ui-sans-serif, \"Segoe UI\", system-ui, Ubuntu, \"Helvetica Neue\", sans-serif",
      "monospace": "ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace",
      "body": "\"SF Pro\", ui-sans-serif, \"Segoe UI\", system-ui, Ubuntu, \"Helvetica Neue\", sans-serif"
    },
    "fontFamily": {
      "normal": "-apple-system, BlinkMacSystemFont, \"Segoe UI\", Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\"",
      "mono": "SFMono-Regular, Consolas, \"Liberation Mono\", Menlo, Courier, monospace",
      "title": "-apple-system, BlinkMacSystemFont, \"Segoe UI\", Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\""
    },
    "animation": {
      "easeOutCubic": "cubic-bezier(0.33, 1, 0.68, 1)"
    },
    "borderWidths": [0, "1px"],
    "breakpoints": ["350px", "544px", "768px", "1012px", "1280px"],
    "fonts": {
      "normal": "-apple-system, BlinkMacSystemFont, \"Segoe UI\", Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\"",
      "mono": "SFMono-Regular, Consolas, \"Liberation Mono\", Menlo, Courier, monospace",
      "title": "-apple-system, BlinkMacSystemFont, \"Segoe UI\", Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\""
    },
    "fontSizes": ["10px", "11px", "12px", "14px", "16px", "18px", "20px", "24px", "28px", "29px", "35px", "36px", "47px", "62px"],
    "fontWeights": {
      "light": 300,
      "normal": 400,
      "medium": 500,
      "semibold": 600,
      "bold": 700,
      "extraLight": 200
    },
    "lineHeights": {
      "default": 1.429,
      "condensed": 1.143,
      "condensedUltra": 1,
      "relaxed": 1.714
    },
    "radii": ["0px", "3px", "4px", "6px", "8px", "9999999px"],
    "size": {
      "4": "4px",
      "8": "8px",
      "12": "12px",
      "16": "16px",
      "20": "20px",
      "24": "24px",
      "28": "28px",
      "32": "32px",
      "36": "36px",
      "40": "40px",
      "44": "44px",
      "48": "48px",
      "64": "64px",
      "80": "80px",
      "96": "96px",
      "112": "112px",
      "128": "128px",
      "144": "144px"
    },
    "space": ["0px", "4px", "8px", "16px", "24px", "32px", "40px", "48px", "64px", "80px", "96px", "112px", "128px"],
    "colorSchemes": {
      "light": {
        "colors": {
          "text": {
            "default": "#172b4d",
            "subtle": "#44546f",
            "subtlest": "#626f86",
            "disabled": "#8590a2",
            "inverse": "#ffffff",
            "brand": "#0c66e4",
            "selected": "#0c66e4",
            "danger": "#ae2a19",
            "success": "#216e4e",
            "discovery": "#5e4db2",
            "information": "#0055cc",
            "accent": {
              "blue": {
                "default": "#0055cc",
                "bolder": "#09326c"
              },
              "red": {
                "default": "#ae2a19",
                "bolder": "#601e16"
              },
              "orange": {
                "default": "#974f0c",
                "bolder": "#5f3811"
              },
              "yellow": {
                "default": "#7f5f01",
                "bolder": "#533f04"
              },
              "green": {
                "default": "#216e4e",
                "bolder": "#164b35"
              },
              "purple": {
                "default": "#5e4db2",
                "bolder": "#352c63"
              },
              "teal": {
                "default": "#206b74",
                "bolder": "#1d474c"
              },
              "magenta": {
                "default": "#943d73",
                "bolder": "#50253f"
              },
              "gray": {
                "default": "#44546f",
                "bolder": "#091e42"
              },
              "lime": {
                "default": "#4c6b1f",
                "bolder": "#37471f"
              }
            },
            "warning": {
              "default": "#974f0c",
              "inverse": "#172b4d"
            }
          },
          "icon": {
            "default": "#44546f",
            "subtle": "#626f86",
            "inverse": "#ffffff",
            "disabled": "#8590a2",
            "brand": "#0c66e4",
            "selected": "#0c66e4",
            "danger": "#e34935",
            "success": "#22a06b",
            "discovery": "#8270db",
            "information": "#1d7afc",
            "accent": {
              "blue": "#1d7afc",
              "red": "#e34935",
              "orange": "#d97008",
              "yellow": "#b38600",
              "green": "#22a06b",
              "purple": "#8270db",
              "teal": "#1d9aaa",
              "magenta": "#cd519d",
              "gray": "#758195",
              "lime": "#6a9a23"
            },
            "warning": {
              "default": "#d97008",
              "inverse": "#172b4d"
            }
          },
          "border": {
            "default": "#091e4224",
            "inverse": "#ffffff",
            "focused": "#388bff",
            "input": "#091e4224",
            "disabled": "#091e420f",
            "brand": "#0c66e4",
            "selected": "#0c66e4",
            "danger": "#e34935",
            "warning": "#d97008",
            "success": "#22a06b",
            "discovery": "#8270db",
            "information": "#1d7afc",
            "subtle": "#091e420f",
            "accent": {
              "blue": "#1d7afc",
              "red": "#e34935",
              "orange": "#d97008",
              "yellow": "#b38600",
              "green": "#22a06b",
              "purple": "#8270db",
              "teal": "#1d9aaa",
              "magenta": "#cd519d",
              "gray": "#758195"
            },
            "table": {
              "default": "#091e4224"
            }
          },
          "background": {
            "disabled": "#f1f2f4",
            "accent": {
              "blue": {
                "subtlest": "#e9f2ff",
                "subtler": "#cce0ff",
                "subtle": "#579dff",
                "bolder": "#0c66e4"
              },
              "red": {
                "subtlest": "#ffedeb",
                "subtler": "#ffd2cc",
                "subtle": "#f87462",
                "bolder": "#ca3521"
              },
              "orange": {
                "subtlest": "#fff4e5",
                "subtler": "#ffe2bd",
                "subtle": "#faa53d",
                "bolder": "#b65c02"
              },
              "yellow": {
                "subtlest": "#fff7d6",
                "subtler": "#f8e6a0",
                "subtle": "#e2b203",
                "bolder": "#946f00"
              },
              "green": {
                "subtlest": "#dffcf0",
                "subtler": "#baf3db",
                "subtle": "#4bce97",
                "bolder": "#1f845a"
              },
              "teal": {
                "subtlest": "#e3fafc",
                "subtler": "#c1f0f5",
                "subtle": "#60c6d2",
                "bolder": "#1d7f8c"
              },
              "purple": {
                "subtlest": "#f3f0ff",
                "subtler": "#dfd8fd",
                "subtle": "#9f8fef",
                "bolder": "#6e5dc6"
              },
              "magenta": {
                "subtlest": "#ffecf8",
                "subtler": "#fdd0ec",
                "subtle": "#e774bb",
                "bolder": "#ae4787"
              },
              "gray": {
                "subtlest": "#f1f2f4",
                "subtler": "#dcdfe4",
                "subtle": "#8590a2",
                "bolder": "#626f86"
              },
              "lime": {
                "subtlest": "#eefbda",
                "subtler": "#d3f1a7",
                "subtle": "#94c748",
                "bolder": "#5b7f24"
              }
            },
            "inverse": {
              "subtle": {
                "default": "#00000029",
                "hovered": "#0000003d",
                "pressed": "#00000052"
              }
            },
            "input": {
              "default": "#ffffff",
              "hovered": "#f7f8f9",
              "pressed": "#ffffff"
            },
            "neutral": {
              "default": {
                "[default]": "#091e420f",
                "hovered": "#091e4224",
                "pressed": "#091e4224"
              },
              "subtle": {
                "default": "#00000000",
                "hovered": "#091e420f",
                "pressed": "#091e4224"
              },
              "bold": {
                "default": "#44546f",
                "hovered": "#2c3e5d",
                "pressed": "#172b4d"
              }
            },
            "brand": {
              "bold": {
                "default": "#0c66e4",
                "hovered": "#0055cc",
                "pressed": "#09326c"
              }
            },
            "selected": {
              "default": {
                "[default]": "#e9f2ff",
                "hovered": "#cce0ff",
                "pressed": "#85b8ff"
              },
              "bold": {
                "default": "#0c66e4",
                "hovered": "#0055cc",
                "pressed": "#09326c"
              }
            },
            "danger": {
              "default": {
                "[default]": "#ffedeb",
                "hovered": "#ffd2cc",
                "pressed": "#ff9c8f"
              },
              "bold": {
                "default": "#ca3521",
                "hovered": "#ae2a19",
                "pressed": "#601e16"
              }
            },
            "warning": {
              "default": {
                "[default]": "#fff7d6",
                "hovered": "#f8e6a0",
                "pressed": "#f8e6a0"
              },
              "bold": {
                "default": "#e2b203",
                "hovered": "#cf9f02",
                "pressed": "#b38600"
              }
            },
            "success": {
              "default": {
                "[default]": "#dffcf0",
                "hovered": "#baf3db",
                "pressed": "#7ee2b8"
              },
              "bold": {
                "default": "#1f845a",
                "hovered": "#216e4e",
                "pressed": "#164b35"
              }
            },
            "discovery": {
              "default": {
                "[default]": "#f3f0ff",
                "hovered": "#dfd8fd",
                "pressed": "#b8acf6"
              },
              "bold": {
                "default": "#6e5dc6",
                "hovered": "#5e4db2",
                "pressed": "#352c63"
              }
            },
            "information": {
              "default": {
                "[default]": "#e9f2ff",
                "hovered": "#cce0ff",
                "pressed": "#85b8ff"
              },
              "bold": {
                "default": "#0c66e4",
                "hovered": "#0055cc",
                "pressed": "#09326c"
              }
            }
          },
          "blanket": {
            "default": "#091e427d",
            "selected": "#388bff14",
            "danger": "#ef5c4814"
          },
          "interaction": {
            "hovered": "#00000029",
            "pressed": "#00000052"
          },
          "skeleton": {
            "default": "#091e420f",
            "subtle": "#091e4208"
          },
          "link": {
            "default": "#0c66e4",
            "pressed": "#0055cc",
            "visited": "#5e4db2"
          },
          "chart": {
            "brand": {
              "default": "#1d7afc",
              "hovered": "#0c66e4"
            },
            "neutral": {
              "default": "#8590a2",
              "hovered": "#758195"
            },
            "success": {
              "default": {
                "[default]": "#22a06b",
                "hovered": "#1f845a"
              },
              "bold": {
                "default": "#216e4e",
                "hovered": "#164b35"
              }
            },
            "danger": {
              "default": {
                "[default]": "#ef5c48",
                "hovered": "#e34935"
              },
              "bold": {
                "default": "#ae2a19",
                "hovered": "#601e16"
              }
            },
            "warning": {
              "default": {
                "[default]": "#b38600",
                "hovered": "#946f00"
              },
              "bold": {
                "default": "#7f5f01",
                "hovered": "#533f04"
              }
            },
            "information": {
              "default": {
                "[default]": "#388bff",
                "hovered": "#1d7afc"
              },
              "bold": {
                "default": "#0055cc",
                "hovered": "#09326c"
              }
            },
            "discovery": {
              "default": {
                "[default]": "#8f7ee7",
                "hovered": "#8270db"
              },
              "bold": {
                "default": "#5e4db2",
                "hovered": "#352c63"
              }
            },
            "categorical": {
              "1": {
                "default": "#1d9aaa",
                "hovered": "#1d7f8c"
              },
              "2": {
                "default": "#5e4db2",
                "hovered": "#352c63"
              },
              "3": {
                "default": "#d97008",
                "hovered": "#b65c02"
              },
              "4": {
                "default": "#943d73",
                "hovered": "#50253f"
              },
              "5": {
                "default": "#09326c",
                "hovered": "#092957"
              },
              "6": {
                "default": "#8f7ee7",
                "hovered": "#8270db"
              },
              "7": {
                "default": "#50253f",
                "hovered": "#421f34"
              },
              "8": {
                "default": "#974f0c",
                "hovered": "#5f3811"
              }
            },
            "blue": {
              "bold": {
                "default": "#388bff",
                "hovered": "#1d7afc"
              },
              "bolder": {
                "default": "#1d7afc",
                "hovered": "#0c66e4"
              },
              "boldest": {
                "default": "#0055cc",
                "hovered": "#09326c"
              }
            },
            "red": {
              "bold": {
                "default": "#ef5c48",
                "hovered": "#e34935"
              },
              "bolder": {
                "default": "#e34935",
                "hovered": "#ca3521"
              },
              "boldest": {
                "default": "#ae2a19",
                "hovered": "#601e16"
              }
            },
            "orange": {
              "bold": {
                "default": "#d97008",
                "hovered": "#b65c02"
              },
              "bolder": {
                "default": "#b65c02",
                "hovered": "#974f0c"
              },
              "boldest": {
                "default": "#974f0c",
                "hovered": "#5f3811"
              }
            },
            "yellow": {
              "bold": {
                "default": "#b38600",
                "hovered": "#946f00"
              },
              "bolder": {
                "default": "#946f00",
                "hovered": "#7f5f01"
              },
              "boldest": {
                "default": "#7f5f01",
                "hovered": "#533f04"
              }
            },
            "green": {
              "bold": {
                "default": "#22a06b",
                "hovered": "#1f845a"
              },
              "bolder": {
                "default": "#1f845a",
                "hovered": "#216e4e"
              },
              "boldest": {
                "default": "#216e4e",
                "hovered": "#164b35"
              }
            },
            "teal": {
              "bold": {
                "default": "#1d9aaa",
                "hovered": "#1d7f8c"
              },
              "bolder": {
                "default": "#1d7f8c",
                "hovered": "#206b74"
              },
              "boldest": {
                "default": "#206b74",
                "hovered": "#1d474c"
              }
            },
            "purple": {
              "bold": {
                "default": "#8f7ee7",
                "hovered": "#8270db"
              },
              "bolder": {
                "default": "#8270db",
                "hovered": "#6e5dc6"
              },
              "boldest": {
                "default": "#5e4db2",
                "hovered": "#352c63"
              }
            },
            "magenta": {
              "bold": {
                "default": "#da62ac",
                "hovered": "#cd519d"
              },
              "bolder": {
                "default": "#cd519d",
                "hovered": "#ae4787"
              },
              "boldest": {
                "default": "#943d73",
                "hovered": "#50253f"
              }
            },
            "gray": {
              "bold": {
                "default": "#8590a2",
                "hovered": "#758195"
              },
              "bolder": {
                "default": "#758195",
                "hovered": "#626f86"
              },
              "boldest": {
                "default": "#44546f",
                "hovered": "#2c3e5d"
              }
            },
            "lime": {
              "bold": {
                "default": "#6a9a23",
                "hovered": "#5b7f24"
              },
              "bolder": {
                "default": "#5b7f24",
                "hovered": "#4c6b1f"
              },
              "boldest": {
                "default": "#4c6b1f",
                "hovered": "#37471f"
              }
            }
          },
          "elevation": {
            "surface": {
              "default": {
                "[default]": "#ffffff",
                "hovered": "#f1f2f4",
                "pressed": "#dcdfe4"
              },
              "sunken": "#f7f8f9",
              "raised": {
                "default": "#ffffff",
                "hovered": "#f1f2f4",
                "pressed": "#dcdfe4"
              },
              "overlay": {
                "default": "#ffffff",
                "hovered": "#f1f2f4",
                "pressed": "#dcdfe4"
              }
            },
            "shadow": {
              "overflow": {
                "spread": "#091e4229",
                "perimeter": "#091e421f"
              }
            }
          },
          "shadows": {
            "shadow": {
              "overflow": {
                "spread": "#091e4229",
                "perimeter": "#091e421f"
              }
            }
          }
        },
        "shadows": {
          "elevation": {
            "shadow": {
              "raised": "0px 1px 1px 0px #091e4240, 0px 0px 1px 0px #091e424f",
              "overflow": {
                "default": "0px 0px 12px 0px #0304048f, 0px 0px 1px 0px #03040480"
              },
              "overlay": "0px 8px 12px 0px #091e4226, 0px 0px 1px 0px #091e424f"
            }
          },
          "shadows": {
            "shadow": {
              "raised": "0px 1px 1px 0px #091e4240, 0px 0px 1px 0px #091e424f",
              "overflow": {
                "default": "0px 0px 12px 0px #0304048f, 0px 0px 1px 0px #03040480"
              },
              "overlay": "0px 8px 12px 0px #091e4226, 0px 0px 1px 0px #091e424f"
            }
          }
        }
      },
      "dark": {
        "colors": {
          "text": {
            "default": "#c7d1db",
            "subtle": "#9fadbc",
            "subtlest": "#8696a7",
            "disabled": "#596773",
            "inverse": "#161a1d",
            "brand": "#579dff",
            "selected": "#579dff",
            "danger": "#ff9c8f",
            "success": "#7ee2b8",
            "discovery": "#b8acf6",
            "information": "#85b8ff",
            "accent": {
              "blue": {
                "default": "#85b8ff",
                "bolder": "#cce0ff"
              },
              "red": {
                "default": "#ff9c8f",
                "bolder": "#ffd2cc"
              },
              "orange": {
                "default": "#fec57b",
                "bolder": "#ffe2bd"
              },
              "yellow": {
                "default": "#f5cd47",
                "bolder": "#f8e6a0"
              },
              "green": {
                "default": "#7ee2b8",
                "bolder": "#baf3db"
              },
              "purple": {
                "default": "#b8acf6",
                "bolder": "#dfd8fd"
              },
              "teal": {
                "default": "#8bdbe5",
                "bolder": "#c1f0f5"
              },
              "magenta": {
                "default": "#f797d2",
                "bolder": "#fdd0ec"
              },
              "gray": {
                "default": "#9fadbc",
                "bolder": "#c7d1db"
              },
              "lime": {
                "default": "#b3df72",
                "bolder": "#d3f1a7"
              }
            },
            "warning": {
              "default": "#f5cd47",
              "inverse": "#161a1d"
            }
          },
          "icon": {
            "default": "#9fadbc",
            "subtle": "#8696a7",
            "inverse": "#161a1d",
            "disabled": "#596773",
            "brand": "#579dff",
            "selected": "#579dff",
            "danger": "#ef5c48",
            "success": "#2abb7f",
            "discovery": "#8f7ee7",
            "information": "#388bff",
            "accent": {
              "blue": "#388bff",
              "red": "#ef5c48",
              "orange": "#f18d13",
              "yellow": "#cf9f02",
              "green": "#2abb7f",
              "purple": "#8f7ee7",
              "teal": "#37b4c3",
              "magenta": "#da62ac",
              "gray": "#738496",
              "lime": "#82b536"
            },
            "warning": {
              "default": "#cf9f02",
              "inverse": "#161a1d"
            }
          },
          "border": {
            "default": "#a6c5e229",
            "inverse": "#161a1d",
            "focused": "#cce0ff",
            "input": "#a6c5e229",
            "disabled": "#a1bdd914",
            "brand": "#579dff",
            "selected": "#579dff",
            "danger": "#ef5c48",
            "warning": "#f18d13",
            "success": "#2abb7f",
            "discovery": "#8f7ee7",
            "information": "#388bff",
            "subtle": "#a1bdd914",
            "accent": {
              "blue": "#388bff",
              "red": "#ef5c48",
              "orange": "#faa53d",
              "yellow": "#cf9f02",
              "green": "#2abb7f",
              "purple": "#8f7ee7",
              "teal": "#37b4c3",
              "magenta": "#da62ac",
              "table": {
                "default": "#a6c5e229"
              },
              "gray": "#738496"
            }
          },
          "background": {
            "disabled": "#a1bdd914",
            "accent": {
              "blue": {
                "subtlest": "#092957",
                "subtler": "#09326c",
                "subtle": "#0055cc",
                "bolder": "#579dff"
              },
              "red": {
                "subtlest": "#4f1c16",
                "subtler": "#601e16",
                "subtle": "#ae2a19",
                "bolder": "#f87462"
              },
              "orange": {
                "subtlest": "#4a2b0f",
                "subtler": "#5f3811",
                "subtle": "#974f0c",
                "bolder": "#faa53d"
              },
              "yellow": {
                "subtlest": "#3f3102",
                "subtler": "#533f04",
                "subtle": "#7f5f01",
                "bolder": "#e2b203"
              },
              "green": {
                "subtlest": "#143c2b",
                "subtler": "#164b35",
                "subtle": "#216e4e",
                "bolder": "#4bce97"
              },
              "teal": {
                "subtlest": "#153337",
                "subtler": "#1d474c",
                "subtle": "#206b74",
                "bolder": "#60c6d2"
              },
              "purple": {
                "subtlest": "#2b273f",
                "subtler": "#352c63",
                "subtle": "#5e4db2",
                "bolder": "#9f8fef"
              },
              "magenta": {
                "subtlest": "#421f34",
                "subtler": "#50253f",
                "subtle": "#943d73",
                "bolder": "#e774bb"
              },
              "gray": {
                "subtlest": "#2c333a",
                "subtler": "#2c333a",
                "subtle": "#596773",
                "bolder": "#8696a7"
              },
              "lime": {
                "subtlest": "#2a3818",
                "subtler": "#37471f",
                "subtle": "#4c6b1f",
                "bolder": "#94c748"
              }
            },
            "inverse": {
              "subtle": {
                "default": "#ffffff29",
                "hovered": "#ffffff3d",
                "pressed": "#ffffff52"
              }
            },
            "input": {
              "default": "#1d2125",
              "hovered": "#22272b",
              "pressed": "#1d2125"
            },
            "neutral": {
              "default": {
                "[default]": "#a1bdd914",
                "hovered": "#a6c5e229",
                "pressed": "#bfdbf847"
              },
              "subtle": {
                "default": "#00000000",
                "hovered": "#a1bdd914",
                "pressed": "#a6c5e229"
              },
              "bold": {
                "default": "#9fadbc",
                "hovered": "#b6c2cf",
                "pressed": "#c7d1db"
              }
            },
            "brand": {
              "bold": {
                "default": "#579dff",
                "hovered": "#85b8ff",
                "pressed": "#cce0ff"
              }
            },
            "selected": {
              "default": {
                "[default]": "#092957",
                "hovered": "#09326c",
                "pressed": "#0055cc"
              },
              "bold": {
                "default": "#579dff",
                "hovered": "#85b8ff",
                "pressed": "#cce0ff"
              }
            },
            "danger": {
              "default": {
                "[default]": "#4f1c16",
                "hovered": "#601e16",
                "pressed": "#ae2a19"
              },
              "bold": {
                "default": "#f87462",
                "hovered": "#ff9c8f",
                "pressed": "#ffd2cc"
              }
            },
            "warning": {
              "default": {
                "[default]": "#3f3102",
                "hovered": "#533f04",
                "pressed": "#7f5f01"
              },
              "bold": {
                "default": "#e2b203",
                "hovered": "#f5cd47",
                "pressed": "#f8e6a0"
              }
            },
            "success": {
              "default": {
                "[default]": "#143c2b",
                "hovered": "#164b35",
                "pressed": "#216e4e"
              },
              "bold": {
                "default": "#4bce97",
                "hovered": "#7ee2b8",
                "pressed": "#baf3db"
              }
            },
            "discovery": {
              "default": {
                "[default]": "#2b273f",
                "hovered": "#352c63",
                "pressed": "#5e4db2"
              },
              "bold": {
                "default": "#9f8fef",
                "hovered": "#b8acf6",
                "pressed": "#dfd8fd"
              }
            },
            "information": {
              "default": {
                "[default]": "#092957",
                "hovered": "#09326c",
                "pressed": "#0055cc"
              },
              "bold": {
                "default": "#579dff",
                "hovered": "#85b8ff",
                "pressed": "#cce0ff"
              }
            }
          },
          "blanket": {
            "default": "#10121499",
            "selected": "#1d7afc14",
            "danger": "#e3493514"
          },
          "interaction": {
            "hovered": "#00000029",
            "pressed": "#00000052",
            "inverse": {
              "hovered": "#ffffff33",
              "pressed": "#ffffff5c"
            }
          },
          "skeleton": {
            "default": "#a1bdd914",
            "subtle": "#bcd6f00a"
          },
          "link": {
            "default": "#579dff",
            "pressed": "#85b8ff",
            "visited": "#b8acf6"
          },
          "chart": {
            "brand": {
              "default": "#388bff",
              "hovered": "#579dff"
            },
            "neutral": {
              "default": "#738496",
              "hovered": "#8696a7"
            },
            "success": {
              "default": {
                "[default]": "#2abb7f",
                "hovered": "#4bce97"
              },
              "bold": {
                "default": "#7ee2b8",
                "hovered": "#baf3db"
              }
            },
            "danger": {
              "default": {
                "[default]": "#e34935",
                "hovered": "#ef5c48",
                "pressed": "#ae2a19"
              },
              "bold": {
                "default": "#ff9c8f",
                "hovered": "#ffd2cc",
                "pressed": "#ffedeb"
              }
            },
            "warning": {
              "default": {
                "[default]": "#cf9f02",
                "hovered": "#e2b203"
              },
              "bold": {
                "default": "#f5cd47",
                "hovered": "#f8e6a0"
              }
            },
            "information": {
              "default": {
                "[default]": "#1d7afc",
                "hovered": "#388bff"
              },
              "bold": {
                "default": "#85b8ff",
                "hovered": "#cce0ff"
              }
            },
            "discovery": {
              "default": {
                "[default]": "#8270db",
                "hovered": "#8f7ee7"
              },
              "bold": {
                "default": "#b8acf6",
                "hovered": "#dfd8fd"
              }
            },
            "categorical": {
              "1": {
                "default": "#1d9aaa",
                "hovered": "#37b4c3"
              },
              "2": {
                "default": "#b8acf6",
                "hovered": "#dfd8fd"
              },
              "3": {
                "default": "#d97008",
                "hovered": "#f18d13"
              },
              "4": {
                "default": "#f797d2",
                "hovered": "#fdd0ec"
              },
              "5": {
                "default": "#cce0ff",
                "hovered": "#e9f2ff"
              },
              "6": {
                "default": "#8270db",
                "hovered": "#8f7ee7"
              },
              "7": {
                "default": "#fdd0ec",
                "hovered": "#ffecf8"
              },
              "8": {
                "default": "#fec57b",
                "hovered": "#ffe2bd"
              }
            },
            "blue": {
              "bold": {
                "default": "#1d7afc",
                "hovered": "#388bff"
              },
              "bolder": {
                "default": "#388bff",
                "hovered": "#579dff"
              },
              "boldest": {
                "default": "#85b8ff",
                "hovered": "#cce0ff"
              }
            },
            "red": {
              "bold": {
                "default": "#e34935",
                "hovered": "#ef5c48"
              },
              "bolder": {
                "default": "#ef5c48",
                "hovered": "#f87462"
              },
              "boldest": {
                "default": "#ff9c8f",
                "hovered": "#ffd2cc"
              }
            },
            "orange": {
              "bold": {
                "default": "#f18d13",
                "hovered": "#faa53d"
              },
              "bolder": {
                "default": "#faa53d",
                "hovered": "#fec57b"
              },
              "boldest": {
                "default": "#fec57b",
                "hovered": "#ffe2bd"
              }
            },
            "yellow": {
              "bold": {
                "default": "#cf9f02",
                "hovered": "#e2b203"
              },
              "bolder": {
                "default": "#e2b203",
                "hovered": "#f5cd47"
              },
              "boldest": {
                "default": "#f5cd47",
                "hovered": "#f8e6a0"
              }
            },
            "green": {
              "bold": {
                "default": "#2abb7f",
                "hovered": "#4bce97"
              },
              "bolder": {
                "default": "#4bce97",
                "hovered": "#7ee2b8"
              },
              "boldest": {
                "default": "#7ee2b8",
                "hovered": "#baf3db"
              }
            },
            "teal": {
              "bold": {
                "default": "#37b4c3",
                "hovered": "#60c6d2"
              },
              "bolder": {
                "default": "#60c6d2",
                "hovered": "#8bdbe5"
              },
              "boldest": {
                "default": "#8bdbe5",
                "hovered": "#c1f0f5"
              }
            },
            "purple": {
              "bold": {
                "default": "#8270db",
                "hovered": "#8f7ee7"
              },
              "bolder": {
                "default": "#8f7ee7",
                "hovered": "#9f8fef"
              },
              "boldest": {
                "default": "#b8acf6",
                "hovered": "#dfd8fd"
              }
            },
            "magenta": {
              "bold": {
                "default": "#cd519d",
                "hovered": "#da62ac"
              },
              "bolder": {
                "default": "#da62ac",
                "hovered": "#e774bb"
              },
              "boldest": {
                "default": "#f797d2",
                "hovered": "#fdd0ec"
              }
            },
            "gray": {
              "bold": {
                "default": "#738496",
                "hovered": "#8696a7"
              },
              "bolder": {
                "default": "#8696a7",
                "hovered": "#9fadbc"
              },
              "boldest": {
                "default": "#9fadbc",
                "hovered": "#b6c2cf"
              }
            },
            "lime": {
              "bold": {
                "default": "#82b536",
                "hovered": "#94c748"
              },
              "bolder": {
                "default": "#94c748",
                "hovered": "#b3df72"
              },
              "boldest": {
                "default": "#b3df72",
                "hovered": "#d3f1a7"
              }
            }
          },
          "elevation": {
            "surface": {
              "default": {
                "[default]": "#1d2125",
                "hovered": "#22272b",
                "pressed": "#22272b"
              },
              "sunken": "#161a1d",
              "raised": {
                "default": "#22272b",
                "hovered": "#22272b",
                "pressed": "#2c333a"
              },
              "overlay": {
                "default": "#22272b",
                "hovered": "#2c333a",
                "pressed": "#2c333a"
              }
            },
            "shadow": {
              "overflow": {
                "spread": "#0304048f",
                "perimeter": "#091e421f"
              }
            }
          },
          "shadows": {
            "shadow": {
              "overflow": {
                "spread": "#0304048f",
                "perimeter": "#091e421f"
              }
            }
          }
        },
        "shadows": {
          "elevation": {
            "shadow": {
              "raised": "0px 1px 1px 0px #03040480, 0px 0px 1px 0px #03040480",
              "overflow": {
                "default": "0px 0px 12px 0px #0304048f, 0px 0px 1px 0px #03040480"
              },
              "overlay": "0px 0px 0px 1px #bcd6f00a, 0px 8px 12px 0px #0304045c, 0px 0px 1px 0px #03040480"
            }
          },
          "shadows": {
            "shadow": {
              "raised": "0px 1px 1px 0px #03040480, 0px 0px 1px 0px #03040480",
              "overflow": {
                "default": "0px 0px 12px 0px #0304048f, 0px 0px 1px 0px #03040480"
              },
              "overlay": "0px 0px 0px 1px #bcd6f00a, 0px 8px 12px 0px #0304045c, 0px 0px 1px 0px #03040480"
            }
          }
        }
      }
    }
  }
};

export { themePreval as default };
